type AppLogoProps = object

const AppLogo = ({}: AppLogoProps) => {
  return <div className=''></div>
}

export default AppLogo
